import React from 'react'

import {
  Box,
  Body3,
  Color,
  Display,
  JustifyContent,
  AlignItems,
  Heading6,
  FontWeight,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

const BoxWithPadding = withCitrusTheme(Box, () => ({
  padding: '0.25rem 0.5rem 0.2rem 0.5rem',
}))

const RecipeCustomisationTitle = () => (
  <Box
    display={Display.Flex}
    justifyContent={JustifyContent.FlexStart}
    gap={2}
    alignItems={AlignItems.Center}
  >
    <Heading6>Customise your meal</Heading6>

    <BoxWithPadding bg={Color.Success_600}>
      <Body3 color={Color.White} fontWeight={FontWeight.Bold}>
        NEW
      </Body3>
    </BoxWithPadding>
  </Box>
)

export { RecipeCustomisationTitle }
